import * as React from "react";

import { ColorModeScript } from "@chakra-ui/react";
import { ClerkProvider } from "@clerk/clerk-react";
import * as Sentry from "@sentry/react";
import ReactDOM from "react-dom/client";
import "./index.css";

// fonts
import "@fontsource-variable/inter";
import "@fontsource-variable/quicksand";
import "@fontsource-variable/roboto-flex";

Sentry.init({
  dsn: `${import.meta.env.VITE_SENTRY_DSN}`,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false
    })
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

// Let's make sure the required env vars exist before going forward
const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

if (!PUBLISHABLE_KEY) {
  throw new Error("Missing ClerkPublishable Key");
}

import App from "./App";

import { theme } from "~/styles/theme";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <ClerkProvider
      publishableKey={PUBLISHABLE_KEY}
      appearance={{
        variables: { colorPrimary: "#41bda3" },
        elements: {
          formButtonPrimary: "bg-[#41bda3] hover:bg-[#2d9d78] text-sm normal-case",
          card: "dark:bg-gray-800",
          footer: "dark:text-gray-100",
          headerTitle: "dark:text-gray-100",
          headerSubtitle: "dark:text-gray-300",
          socialButtonsBlockButton: "dark:bg-gray-700 dark:border-gray-600 dark:text-gray-100",
          formFieldInput: "dark:bg-gray-700 dark:text-gray-100 dark:border-gray-600",
          form: "dark:bg-gray-800",
          formFieldLabel: "dark:text-gray-100"
        }
      }}
    >
      <ColorModeScript initialColorMode={theme.config?.initialColorMode} />
      <App />
    </ClerkProvider>
  </React.StrictMode>
);
